import React, { useState, useEffect } from "react";
import axios from 'helpers/api';
import { createIframeReportBlobUrl } from 'helpers/iframeReportPreview';

const IframeContainerNeedRefill = ({ id, identifier, csvFlag, setPrintLoader, setExportLoader, setcsvFlag }) => {
    const [iframeSrc, setIframeSrc] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchHtmlContent = async () => {
        let tokenStr = localStorage.getItem("accessToken");
        setLoading(true);
        setError(null);
        if (csvFlag) {
            setExportLoader(true);
        } else {
            setPrintLoader(true);
        }
        try {
            const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}` + "/cycles/get-cycle-refill-status-report/" + identifier + '/' + id + (csvFlag ? '?is_print=csv' : ''), { headers: { 'Authorization': `Bearer ${tokenStr}` } });
            if (!(response.data.status)) {
                setError(response.data.message);
            }
            if (!csvFlag) {
                const { blobUrl } = await createIframeReportBlobUrl(response.data);
                setIframeSrc(blobUrl);
            }
            else {
                const disposition = response.headers['content-disposition'];
                const filename = disposition
                    ? disposition.split('filename=')[1]?.replace(/"/g, '').trim()
                    : 'cycle-refill-status-report.csv';

                const url = URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();

                link.parentNode.removeChild(link);
                URL.revokeObjectURL(url);
            }
        } catch (err) {
            setError("Failed to print content.");
        } finally {
            setLoading(false);
            setExportLoader(false);
            setPrintLoader(false);
            setcsvFlag(false);
        }
    };

    useEffect(() => {
        fetchHtmlContent();
    }, []);

    return (
        <>
            {loading && <div className="text-center">Loading...</div>}
            {error && <div className="text-danger text-center">{error}</div>}
            <div style={{
                height: 0,
                overflow: 'hidden',
                width: 0
            }}>
                {iframeSrc && (
                    <iframe
                        src={iframeSrc}
                        style={{ width: "100%", height: "500px", border: "none" }}
                        title="Preview Content"
                    />
                )}
            </div>
        </>
    );
};

export default IframeContainerNeedRefill;

